import React, { useEffect, useMemo, useState, useRef } from "react";
import PageHeader from "../../components/PageHeader/PageHeader";
import CommonTable from "../../components/CommonTable/CommonTable";
import { FaEye, FaTimes } from "react-icons/fa";
import { useNavigate, useLocation } from "react-router-dom";
import { URLS } from "../../Services/Constant";
import { get } from "../../Services/ApiHandler";
import moment from "moment";
import usePermission from "../../customHook/usePermission";

const WalletTransaction = () => {
  const location = useLocation();
  const [searchText, setSearchText] = useState("");
  const [page, setPage] = useState(location?.state?.page || 1);
  const [totalCount, setTotalCount] = useState(0);
  const [pagination, setPagination] = useState(null);
  const [data, setData] = useState([]);
  const navigate = useNavigate();
  const permission = usePermission();

  const pageRef = useRef(page);

  // keep pageRef in sync with the latest page
  useEffect(() => {
    pageRef.current = page;
  }, [page]);

  // clear state after using it (run only once when component mounts)
  useEffect(() => {
    if (location?.state?.page) {
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, []);

  const handleView = (row) => {
    if (!row) return;
    navigate("/help-edit", {
      state: { data: row, mode: "view", page: pageRef.current },
    });
  };

  const columns = useMemo(() => {
    let d = [
      {
        Header: "S.No",
        accessor: "sno",
        disableSortBy: true,
        Cell: ({ row }) => {
          return (
            <span className="sno">
              {String((row?.index || 0) + 1 + (page - 1) * 10).padStart(2, "0")}
            </span>
          );
        },
      },
      {
        Header: "User Name",
        accessor: "user_name",
        Cell: ({ value }) => {
          return <p className="mb-0">{value || "N/A"}</p>;
        },
      },
      {
        Header: "Type",
        accessor: "type_name",
        Cell: ({ value }) => {
          return <p className="mb-0">{value || "N/A"}</p>;
        },
      },
      {
        Header: "Amount",
        accessor: "amount",
        Cell: ({ value }) => {
          return <p className="mb-0">{value || "N/A"}</p>;
        },
      },
      {
        Header: "Previous Balance (₹)",
        accessor: "pre_amount",
        Cell: ({ value }) => value || "N/A",
      },
      {
        Header: "New Balance (₹)",
        accessor: "new_amount",
        Cell: ({ value }) => value || 0,
      },
    ];

    // let action = {
    //     Header: "Action",
    //     accessor: "action",
    //     disableSortBy: true,
    //     Cell: ({ row }) => {
    //         return (
    //             <>
    //                 {permission?.includes("CAN-VIEW-HELP_AND_SUPPORT") && (
    //                     <button
    //                         className="action-btn"
    //                         onClick={() => handleView(row?.original)}
    //                     >
    //                         <FaEye />
    //                     </button>
    //                 )}
    //             </>
    //         );
    //     },
    // };

    return [...d];
  }, [page, data]);

  const handleClearSearch = () => {
    setSearchText("");
    setPage(1);
  };

  const fetch = async () => {
    try {
      let res = await get(
        `${URLS.USERWALLET}?page=${page || 1}&search=${searchText || ""}`,
      );
      console.log("Help list res:", res);

      if (res?.status === "success") {
        setData(res?.data || []);
        setTotalCount(res?.total_wallet_amount || 0);
        setPagination({
          current_page: res?.current_page || 1,
          last_page: res?.total_pages || 1,
        });
      }
    } catch (error) {
      console.error("Error fetching help support list:", error);
    }
  };

  useEffect(() => {
    fetch();
  }, [page, searchText]);
  console.log("Notificationdata", data);

  return (
    <>
      <PageHeader title="Wallet Transaction" />
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "20px",
        }}
      >
        <h2 style={{ fontSize: "20px", fontWeight: "600", color: "#7a52ab" }}>
          Total Wallet Amount : {totalCount || 0}
        </h2>
        <div className="search-wrapper">
          <input
            type="text"
            placeholder="Search"
            className="search-input"
            value={searchText || ""}
            onChange={(e) => {
              setSearchText(e.target.value);
              setPage(1);
            }}
          />
          {searchText && (
            <FaTimes
              className="search-clear-icon"
              onClick={handleClearSearch}
            />
          )}
        </div>
      </div>
      <CommonTable
        columns={columns}
        data={data || []}
        pagecount={pagination}
        setPageno={setPage}
        pageno={page || 1}
      />
    </>
  );
};

export default WalletTransaction;
